import { render, staticRenderFns } from "./doctorSchedule.vue?vue&type=template&id=18ccef05&scoped=true&"
import script from "./doctorSchedule.vue?vue&type=script&lang=js&"
export * from "./doctorSchedule.vue?vue&type=script&lang=js&"
import style0 from "./doctorSchedule.vue?vue&type=style&index=0&id=18ccef05&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ccef05",
  null
  
)

component.options.__file = "doctorSchedule.vue"
export default component.exports